import axios from "axios";
import { Animate, AuthContext, Loader, ViewContext } from "components/lib";
import { useContext, useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import { table } from "components/lib";
import { Search } from "feather-icons-react/build/IconComponents";
import { QuickLinks } from "./dashboard_quick_links";
import { DashboardEmails } from "./dashboard_emails";
import { Onboarding } from "../../components/onboarding/onboarding";

const BANNER_START = new Date("2026-01-07T00:00:00Z");
const BANNER_END = new Date("2026-02-06T23:59:59Z");
const BANNER_STATES = "FLORIDA, NEW MEXICO AND NEVADA";

export function Dashboard() {
  const [payload, setPayload] = useState();
  const [loading, setLoading] = useState(true);
  const [onboarded, setOnboarded] = useState(false);
  const [permission, setPermission] = useState("");
  const [activeTab, setActiveTab] = useState("service");
  const [tickets, setTickets] = useState([]);
  const [renewals, setRenewals] = useState([]);
  const [endorsements, setEndorsements] = useState([]);
  const [bindRequests, setBindRequests] = useState([]);
  const [quickLinks, setQuickLinks] = useState([]);
  const [quickLinksLoading, setQuickLinksLoading] = useState(true);
  const navigate = useNavigate();
  const context = useContext(ViewContext);
  const Auth = useContext(AuthContext);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  async function fetchTickets() {
    try {
      const res = await axios.get(`/api/tickets/${Auth.user.account_id}`, {
        params: { limit: 10, status: "Active", ticketStatus: "Pending" },
      });
      setTickets(res.data.data);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  }

  async function fetchRenewals() {
    try {
      const res = await axios.get(`/api/renewals/${Auth.user.account_id}`, {
        params: { limit: 10, status: "Active", ticketStatus: "Pending" },
      });
      setRenewals(res.data.data);
    } catch (error) {
      console.error("Error fetching renewals:", error);
    }
  }

  async function fetchEndorsements() {
    try {
      const res = await axios.get("/api/endorsement", {
        params: {
          pageSize: 10,
          account_id: Auth.user.account_id,
          status: "active",
        },
      });
      setEndorsements(res.data.data.data);
    } catch (error) {
      console.error("Error fetching endorsements:", error);
    }
  }

  async function fetchBindRequests() {
    try {
      const res = await axios.get(`/api/bind-requests/${Auth.user.account_id}`, {
        params: { limit: 10, status: "Active", ticketStatus: "Pending" },
      });
      setBindRequests(res.data.data);
    } catch (error) {
      console.error("Error fetching bind requests:", error);
    }
  }

  async function fetchQuickLinks(page = 1, search = "") {
    try {
      setQuickLinksLoading(true);
      const res = await axios.get("/api/quick-links", {
        params: { page, search },
      });
      const sortedLinks = (res.data.data.data || []).sort(
        (a, b) => (a.order || 0) - (b.order || 0)
      );
      setQuickLinks(sortedLinks);
    } catch (error) {
      console.error("Error fetching quick links:", error);
      setQuickLinks([]);
    } finally {
      setQuickLinksLoading(false);
    }
  }

  useEffect(() => {
    runAPI(1, "", true);
    fetchTickets();
    fetchRenewals();
    fetchBindRequests();
    fetchEndorsements();
    fetchQuickLinks();
  }, []);

  async function runAPI(page, search, firstCall) {
    const user = await axios.get("/api/user");
    setOnboarded(user.data.data.onboarded);
    setPermission(user.data.data.permission);

    await axios
      .get(`/api/company?page=${page}&search=${search}&account_id=${Auth.user.account_id}`)
      .then(async (res) => {
        setLoading(false);
        setPayload(res.data.data);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);

        context.notification.show(
          "Failed to load dashboard data",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  useEffect(() => {
    runAPI(1, "", true);
  }, []);

  useEffect(() => {
    if (payload && payload.data) {
      payload.data.map((value, index) => {
        value.premium = formatter.format(value.premium);
      });
    }
  }, [payload]);

  const showBanner =
    Date.now() >= BANNER_START.getTime() && Date.now() <= BANNER_END.getTime();

  return (
    <Animate type="pop">
      {loading ? (
        <Loader />
      ) : !onboarded && permission === "owner" ? (
        <Onboarding onFinish={() => setOnboarded(true)} onSkip={() => setOnboarded(true)} />
      ) : (
        <div className={styles.wrapper}>
          {showBanner && (
            <div className={styles.banner}>
              GREAT NEWS!!! COVER WHALE HAS REOPENED{" "}
              <span className={styles.bannerState}>{BANNER_STATES}</span> FOR NEW
              BUSINESS EFFECTIVE IMMEDIATELY!!! PLEASE SUBMIT ALL APPS THROUGH
              THE COVER BADGER PORTAL. FOR ANY QUESTIONS, PLEASE SEND AN EMAIL TO{" "}
              <a href="mailto:HELLO@COVERBADGER.COM">HELLO@COVERBADGER.COM</a> FOR
              ASSISTANCE.
            </div>
          )}
          <div className={styles.cards}>
            <div className={`${styles.card} ${styles.cardWidget}`}>
              <h2 className={styles.title}>Quick Links</h2>
              <QuickLinks links={quickLinks} loading={quickLinksLoading} />
            </div>
            <div className={`${styles.card} ${styles.cardWidget} ${styles.embedContainer}`}>
              <iframe
                title="google-presentation"
                src="https://docs.google.com/presentation/d/e/2PACX-1vS_RKGf-J_dqujNi-5fUAgY4jIHP7gMi4yoi_2k2v7VXK1LEa91aQdwxgqUTTE1_O0FTJc52zzA7Nld/pubembed?start=true&loop=true&delayms=15000"
                allowFullScreen="true"
              ></iframe>
            </div>
            <div className={`${styles.card} ${styles.cardWidget}`}>
              <h2 className={styles.title}>Cover Badger Contacts</h2>
              <DashboardEmails />
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.tabButtons}>
              <button
                className={`${activeTab === "service" ? styles.active : ""}`}
                onClick={() => setActiveTab("service")}
              >
                Clients Pending Service <span className={styles.badge}>{tickets.length}</span>
              </button>
              <button
                className={`${activeTab === "renewal" ? styles.active : ""}`}
                onClick={() => setActiveTab("renewal")}
              >
                Clients Pending Renewal <span className={styles.badge}>{renewals.length}</span>
              </button>
              <button
                className={`${activeTab === "endorsement" ? styles.active : ""}`}
                onClick={() => setActiveTab("endorsement")}
              >
                Clients Pending Endorsement{" "}
                <span className={styles.badge}>{endorsements.length}</span>
              </button>
              <button
                className={`${activeTab === "bind" ? styles.active : ""}`}
                onClick={() => setActiveTab("bind")}
              >
                Clients Pending Bind <span className={styles.badge}>{bindRequests.length}</span>
              </button>
            </div>

            <div className={styles.tableWrapper}>
              {activeTab === "service" && (
                <>
                  {tickets.length > 0 ? (
                    <>
                      <table className={styles.customTable}>
                        <thead>
                          <tr>
                            <th className={styles.alignLeft}>Insured</th>
                            <th className={styles.alignLeft}>Policy #</th>
                            <th className={styles.alignRight}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tickets.map((ticket) => (
                            <tr key={ticket.id}>
                              <td className={styles.alignLeft}>{ticket.companyName}</td>
                              <td className={styles.alignLeft}>{ticket.policyNumber || ticket.submissionNumber}</td>
                              <td className={styles.alignRight}>
                                <Search
                                  className={styles.actionIcon}
                                  size={16}
                                  onClick={() =>
                                    navigate(`/app/service_center/ticket/${ticket.id}`)
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div className={styles.tableFooter}>
                        <button
                          className={styles.viewAllBtn}
                          onClick={() => navigate("/app/service_center")}
                        >
                          View all tickets
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="text-center text-gray-500 py-4">No pending service tickets</div>
                  )}
                </>
              )}

              {activeTab === "renewal" && (
                <>
                  {renewals.length > 0 ? (
                    <>
                      <table className={styles.customTable}>
                        <thead>
                          <tr>
                            <th className={styles.alignLeft}>Insured</th>
                            <th className={styles.alignLeft}>Submission #</th>
                            <th className={styles.alignRight}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {renewals.map((renewal) => (
                            <tr key={renewal.id}>
                              <td className={styles.alignLeft}>{renewal.companyName}</td>
                              <td className={styles.alignLeft}>{renewal.submissionNumber}</td>
                              <td className={styles.alignRight}>
                                <Search
                                  className={styles.actionIcon}
                                  size={16}
                                  onClick={() => navigate(`/app/renewals/${renewal.id}`)}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div className={styles.tableFooter}>
                        <button
                          className={styles.viewAllBtn}
                          onClick={() => navigate("/app/renewals")}
                        >
                          View all renewals
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="text-center text-gray-500 py-4">No pending renewals</div>
                  )}
                </>
              )}

              {activeTab === "endorsement" && (
                <>
                  {endorsements.length > 0 ? (
                    <>
                      <table className={styles.customTable}>
                        <thead>
                          <tr>
                            <th className={styles.alignLeft}>Insured</th>
                            <th className={styles.alignLeft}>Submission #</th>
                            <th className={styles.alignRight}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {endorsements.map((endorsement) => (
                            <tr key={endorsement.id}>
                              <td className={styles.alignLeft}>{endorsement.company_name}</td>
                              <td className={styles.alignLeft}>{endorsement.submission_number}</td>
                              <td className={styles.alignRight}>
                                <Search
                                  className={styles.actionIcon}
                                  size={16}
                                  onClick={() =>
                                    navigate(`/app/endorsement/v2/view/${endorsement.id}`)
                                  }
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div className={styles.tableFooter}>
                        <button
                          className={styles.viewAllBtn}
                          onClick={() => navigate("/app/endorsements")}
                        >
                          View all endorsements
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="text-center text-gray-500 py-4">No pending endorsements</div>
                  )}
                </>
              )}

              {activeTab === "bind" && (
                <>
                  {bindRequests.length > 0 ? (
                    <>
                      <table className={styles.customTable}>
                        <thead>
                          <tr>
                            <th className={styles.alignLeft}>Insured</th>
                            <th className={styles.alignLeft}>Submission #</th>
                            <th className={styles.alignRight}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bindRequests.map((bindReq) => (
                            <tr key={bindReq.id}>
                              <td className={styles.alignLeft}>{bindReq.companyName}</td>
                              <td className={styles.alignLeft}>{bindReq.submissionNumber}</td>
                              <td className={styles.alignRight}>
                                <Search
                                  className={styles.actionIcon}
                                  size={16}
                                  onClick={() => navigate(`/app/bind-requests/${bindReq.id}`)}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>

                      <div className={styles.tableFooter}>
                        <button
                          className={styles.viewAllBtn}
                          onClick={() => navigate("/app/bind-requests")}
                        >
                          View all bind requests
                        </button>
                      </div>
                    </>
                  ) : (
                    <div className="text-center text-gray-500 py-4">No pending bind requests</div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </Animate>
  );
}
